import '../style/MyProfile.css'

const MyProfile = () => (
    <div id="MyProfile">
        <div className="img-container">
            <img src="/img/profile.svg" className="avatar" alt="profile avatar"></img>
        </div>
        <div className="input-group margin-bottom-20">
            <input type="email" value="Untamedgog@gmail.com" readOnly />
            <button className="submit-btn">Change email</button>
        </div>
        <div className="input-group margin-bottom-50">
            <input type="password" value="*********" readOnly />
            <button className="submit-btn">Change password</button>
        </div>
    </div>
)

export default MyProfile